import {getPlayerLastSessionSummary} from '@/api/api';
import {SessionSummary} from '@/api/MLSChallenge/useGetPlayerAppointments';
import {useQuery} from '@tanstack/react-query';

export type PlayerSessionSummary = {
  sessionSummary: SessionSummary['session'];
  exerciseSummary: SessionSummary['exercises'];
  startTime: number;
  isBaseline: boolean;
  baselineLevel: string;
  isPlayerAssessment: boolean;
  clientSessionSummaryId: string;
  isV3Session: boolean;
  sessionName: string;
};

export type GetPlayerLastSessionSummaryParams = {clientId?: string | null; siteId?: string | null};

export const useGetPlayerLastSessionSummary = ({clientId, siteId}: GetPlayerLastSessionSummaryParams) => {
  return useQuery<PlayerSessionSummary>({
    queryKey: ['player-last-session', clientId],
    queryFn: () => getPlayerLastSessionSummary({clientId, siteId}),
    enabled: !!clientId && !!siteId,
  });
};
